import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import withStyles from 'react-jss';
import DepartmentPage from './DepartmentPage';

const styles = {
  list: {
    gridArea: 'list',
  },
};

const DepartmentListPage = ({ classes }) => {
  return (
    <Switch>
      <Route exact path='/departments'>
        <div>Please use Office or Ships for departments</div>
      </Route>
      <Route
        path='/departments/:id'
        render={({ match }) => <DepartmentPage departmentId={match.params.id} match={match} />}
      />
    </Switch>
  );
};

export default withRouter(withStyles(styles)(DepartmentListPage));
